import { AppEntity } from '@app/icare/db/schema/common'
import { ContactInformationSchema, PostalAddressSchema } from '@app/icare/db/schema/common/embedded'
import { msg } from '@lingui/core/macro'
import { entityId } from '@pkg/db/schema'
import { defineEnum } from '@pkg/shared/utils/enum-builder'
import type { PresetColorType, PresetStatusColorType } from 'antd/es/_util/colors'
import type { LiteralUnion } from 'antd/es/_util/type'
import { z } from 'zod'

export const PharmacyStatusEnum = defineEnum({
  ACTIVE: msg`Aktiv`,
  INACTIVE: msg`Inaktiv`,
})

export type PharmacyStatusType = typeof PharmacyStatusEnum.$.Type

export const PharmacyId = entityId('pharmacy')

export type PharmacyIdType = typeof PharmacyId.Type

export const PharmacySchema = AppEntity.extend({
  id: PharmacyId.schema,
  name: z.coerce.string().min(1).default(''),
  comment: z.coerce.string().default('').nullish(),
  status: z.enum(PharmacyStatusEnum.$.zodEnum()).default(PharmacyStatusEnum.INACTIVE),
  sageComment: z.string().nullish(),
  address: PostalAddressSchema.nullish(),
  contact: ContactInformationSchema.nullish(),
  // sage: SageSyncSchema.nullish(),
})

export type Pharmacy = z.infer<typeof PharmacySchema>

export const pharmacyStatusColor: Record<
  typeof PharmacyStatusEnum.$.Type,
  LiteralUnion<PresetColorType | PresetStatusColorType>
> = {
  [PharmacyStatusEnum.ACTIVE]: 'success',
  [PharmacyStatusEnum.INACTIVE]: 'default',
}
